import React from "react";
import {
  Grid,
  Container,
  Card,
  Typography,
} from "@material-ui/core";
import { TyCStyles } from "./TyCStyles";
import { useTranslation } from "react-i18next";
import { EnumPrivacyTyC } from "../../../commons/EnumsGeneral";

export function DataProtectionPolicy(props) {
  const classes = TyCStyles();
  const { t } = useTranslation();

  return (
    <Grid
      className={
        !props.showSideMenu ? classes.container : classes.hideContainer
      }
    >
      <Container maxWidth={"lg"} className={classes.mainContainer}>
        <Card className={classes.cardContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography align="justify" className={classes.text}>
                <div id="Top" />
                  <h2 className={classes.title}>{t("cookiesPolicyTitle00")}</h2>
                  <hr></hr>
                  
                  <h3 className={classes.subtitles}>
                    {t("cookiesPolicyTitle01")}
                  </h3>
                  <p>{t("cookiesPolicyText01_01")}</p>
                  <p>{t("cookiesPolicyText01_02a")}<b>
                    <a href="mailto:dpdgrupocorreos@correos.com" className={classes.links} target="_blank" rel="noopener noreferrer">{t("cookiesPolicyText01_02b")}</a></b>
                  </p>

                  <h3 className={classes.subtitles}>
                    {t("cookiesPolicyTitle02")}
                  </h3>
                  <p>{t("cookiesPolicyText02_01")}</p>
                  <h5 className={classes.subtitles}>
                    {t("cookiesPolicyText02_a01")}
                  </h5>
                  <p><b>{t("cookiesPolicyText02_a02")}</b></p>
                  <ol type="I">
                    <li>
                      <p>{t("cookiesPolicyText02_a03")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText02_a04a")}<b><a href={EnumPrivacyTyC.GeneralUseConditions} className={classes.links} target="_blank" rel="noopener noreferrer">{t("cookiesPolicyText02_a04b")}</a></b>{t("cookiesPolicyText02_a04c")}</p>
                      <p>{t("cookiesPolicyText02_a05")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText02_a06")}</p>
                    </li>
                  </ol>
                  <p><b>{t("cookiesPolicyText02_a07")}</b></p>
                  <ul type="square">
                    <li>
                      <p>{t("cookiesPolicyText02_a08")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText02_a09")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText02_a10")}</p>
                    </li>
                  </ul>
                  <p><b>{t("cookiesPolicyText02_a11")}</b>{t("cookiesPolicyText02_a12")}</p>
                  <h5 className={classes.subtitles}>
                    {t("cookiesPolicyText02_b01")}
                  </h5>
                  <p><b>{t("cookiesPolicyText02_b02")}</b>{t("cookiesPolicyText02_b03")}</p>
                  <p><b>{t("cookiesPolicyText02_b04")}</b>{t("cookiesPolicyText02_b05")}</p>
                  <p><b>{t("cookiesPolicyText02_b06")}</b>
                    {t("cookiesPolicyText02_b07a")}<b>
                      <a href="mailto:derechos.protecciondatos.correos@correos.com" className={classes.links} target="_blank" rel="noopener noreferrer">{t("cookiesPolicyText02_b07b")}</a></b>
                    {t("cookiesPolicyText02_b07c")}
                  </p>
                  <h5 className={classes.subtitles}>
                    {t("cookiesPolicyText02_c01")}
                  </h5>
                  <p><b>{t("cookiesPolicyText02_c02")}</b>{t("cookiesPolicyText02_c03")}</p>
                  <p><b>{t("cookiesPolicyText02_c04")}</b>{t("cookiesPolicyText02_c05")}</p>
                  <p><b>{t("cookiesPolicyText02_c06")}</b>
                    {t("cookiesPolicyText02_c07a")}<b>
                      <a href="mailto:derechos.protecciondatos.correos@correos.com" className={classes.links} target="_blank" rel="noopener noreferrer">{t("cookiesPolicyText02_c07b")}</a></b>
                    {t("cookiesPolicyText02_c07c")}
                  </p>
                  <h5 className={classes.subtitles}>
                    {t("cookiesPolicyText02_d01")}
                  </h5>
                  <p><b>{t("cookiesPolicyText02_d02")}</b>{t("cookiesPolicyText02_d03")}</p>
                  <p><b>{t("cookiesPolicyText02_d04")}</b>{t("cookiesPolicyText02_d05")}</p>
                  <p><b>{t("cookiesPolicyText02_d06")}</b>
                    {t("cookiesPolicyText02_d07a")}<b>
                      <a href="mailto:derechos.protecciondatos.correos@correos.com" className={classes.links} target="_blank" rel="noopener noreferrer">{t("cookiesPolicyText02_d07b")}</a></b>
                    {t("cookiesPolicyText02_d07c")}
                  </p>
                  <h5 className={classes.subtitles}>
                    {t("cookiesPolicyText02_e01")}
                  </h5>
                  <p><b>{t("cookiesPolicyText02_e02")}</b>{t("cookiesPolicyText02_e03")}</p>
                  <p><b>{t("cookiesPolicyText02_e04")}</b>{t("cookiesPolicyText02_e05")}</p>
                  <p><b>{t("cookiesPolicyText02_e06")}</b>{t("cookiesPolicyText02_e07")}</p>

                  <h3 className={classes.subtitles}>
                    {t("cookiesPolicyTitle03")}
                  </h3>
                  <p>{t("cookiesPolicyText03_01")}</p>
                  <h5 className={classes.subtitles}>
                    {t("cookiesPolicyText03_02")}
                  </h5>
                  <p>{t("cookiesPolicyText03_03")}</p>
                  <p>{t("cookiesPolicyText03_04")}</p>
                  <p>{t("cookiesPolicyText03_05")}</p>
                  <h5 className={classes.subtitles}>
                    {t("cookiesPolicyText03_06")}
                  </h5>
                  <p>{t("cookiesPolicyText03_07")}</p>

                  <h3 className={classes.subtitles}>
                    {t("cookiesPolicyTitle04")}
                  </h3>
                  <p>{t("cookiesPolicyText04_01")}</p>
                  <p>{t("cookiesPolicyText04_02")}</p>
                  <p>{t("cookiesPolicyText04_03")}</p>
                  <p>{t("cookiesPolicyText04_04")}</p>

                  <h3 className={classes.subtitles}>
                    {t("cookiesPolicyTitle05")}
                  </h3>
                  <p>{t("cookiesPolicyText05_01")}</p>
                  <ul type="square">
                    <li>
                      <p>{t("cookiesPolicyText05_02")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText05_03")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText05_04")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText05_05")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText05_06")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText05_07")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText05_08")}</p>
                    </li>
                  </ul>
                  <p>{t("cookiesPolicyText05_09")}</p>
                  <ul type="square">
                    <li>
                      <p>{t("cookiesPolicyText05_10")}</p>
                    </li>
                    <li>
                      <p>{t("cookiesPolicyText05_11a")}<b><a href="mailto:derechos.protecciondatos.correos@correos.com" className={classes.links} target="_blank" rel="noopener noreferrer">{t("cookiesPolicyText05_11b")}</a></b></p>
                    </li>
                  </ul>
                  <p>{t("cookiesPolicyText05_12")}</p>
                  <p>{t("cookiesPolicyText05_13")}</p>
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Grid>
  );
}
